import React, { useRef, useEffect, useState } from 'react';

import {
  FormControl,
  Card,
  CardHeader,
  Checkbox,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useField } from '@unform/core';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import {
  Spinner,
  Accordion,
  SelectDataInTable,
  Table,
  Modal,
} from '~/components';
import { canURL } from '~/helpers';
import api from '~/services/api';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  list: {
    height: 230,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
}));

function CheckboxGroupPagination({
  name,
  label,
  getValue,
  url,
  title,
  unique,
  disabled,
  query,
  cells,
  paginate,
  search,
  height,
}) {
  const inputRef = useRef(null);
  const classes = useStyles();
  const permission = isEqual(canURL(), { read: true });

  const { fieldName, defaultValue, registerField } = useField(name);

  const [items, setItems] = useState([]);
  const [checked, setChecked] = useState(defaultValue || []);

  function handleToggle(value) {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    inputRef.current.value = newChecked;
    getValue(newChecked);
  }

  async function handleGetData() {
    const { data } = await api.get(url, {
      params: { pagesize: 99999, pesquisalista: true, ...query },
    });

    setItems(data.items);
  }

  async function handleSelectAll() {
    const newItems = items.map((value) => value[unique]);

    if (items.length === checked.length) {
      setChecked([]);
      inputRef.current.value = [];
      getValue([]);
    } else {
      setChecked(newItems);
      inputRef.current.value = newItems;
      getValue(newItems);
    }
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    handleGetData();
  }, []);

  return (
    <FormControl style={{ width: '100%' }}>
      <input ref={inputRef} type="hidden" />

      <Card>
        <Table
          checkbox
          showCount
          cells={cells}
          data={items}
          height={height}
          size="medium"
          unique={unique}
          paginate={paginate}
          search={search}
        />
      </Card>
    </FormControl>
  );
}

CheckboxGroupPagination.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  unique: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  url: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  query: PropTypes.objectOf(PropTypes.any),
};

CheckboxGroupPagination.defaultProps = {
  getValue: () => {},
  disabled: false,
  query: {},
};

export default CheckboxGroupPagination;
